import React from 'react';
import { DataList, DataItem } from '@cad-arc';
import { EventDetailsTabView } from '@mark43/cad-api';
import { SubdivisionGrid } from '../helpers/subdivision-grid';
import { TabIndented } from '../../../../../panels/entity-panels/tabs/tab-indented';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';

export function SubdivisionsSection(props: Partial<EventDetailsTabView>): React.ReactElement {
    return (
        <TabSection title="Subdivisions">
            <TabIndented>
                <DataList spacing={4}>
                    <DataList direction="row">
                        <DataItem dataKey={`${props.eventClass} D-Area`}>
                            {props.dispatchArea}
                        </DataItem>
                        <DataItem dataKey={`${props.eventClass} Agency`}>{props.agency}</DataItem>
                    </DataList>
                    <DataList>
                        <DataItem dataKey={`${props.eventClass} Subdivisions`}> </DataItem>
                        <TabIndented>
                            <SubdivisionGrid
                                cells={[
                                    {
                                        label: props.subdivision1Label,
                                        value: props.subdivision1,
                                    },
                                    {
                                        label: props.subdivision2Label,
                                        value: props.subdivision2,
                                    },
                                    {
                                        label: props.subdivision3Label,
                                        value: props.subdivision3,
                                    },
                                    {
                                        label: props.subdivision4Label,
                                        value: props.subdivision4,
                                    },
                                    {
                                        label: props.subdivision5Label,
                                        value: props.subdivision5,
                                    },
                                ].flatMap((subdivision) => {
                                    if (subdivision.label) {
                                        return [
                                            {
                                                label: subdivision.label,
                                                value: subdivision.value,
                                            },
                                        ];
                                    } else {
                                        return [];
                                    }
                                })}
                            />
                        </TabIndented>
                    </DataList>
                </DataList>
            </TabIndented>
        </TabSection>
    );
}
